import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import { useState } from 'react';

import MegaNavigationBodyMobile from 'components/Generic/Header/MegaNavigation/MegaNavigationBodyMobile';
import MegaNavigationMenuItem from 'components/Generic/Header/MegaNavigation/MegaNavigationMenuItem';
import { NavItem } from './MegaNavigation.types';

type Fields = {
  items: Array<NavItem>;
  closeLabel: Field<string>;
};

type MegaNavigationProps = ComponentProps & {
  fields: Fields;
};

const MegaNavigation = (props: MegaNavigationProps): JSX.Element => {
  const [activeCategory, setActiveCategory] = useState<NavItem | null>(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // TODO: implement method below
  const isExperienceEditor = () => {
    return false;
  };
  const categories = () => {
    return props.fields.items
      ?.map((item) => {
        item.hasLinks = !!item.fields.items?.length;
        item.directLink =
          !item.hasLinks && item.fields.pulloutLink.value.href
            ? item.fields.pulloutLink
            : undefined;
        return item;
      })
      .filter((item) => item.hasLinks || item.directLink || isExperienceEditor);
  };
  const toggleMobileMenu = (state: boolean) => {
    setIsMobileMenuOpen(state);
  };

  return (
    <nav className="d-flex meganav">
      <button
        onClick={() => toggleMobileMenu(true)}
        className="btn btn-naked meganav__burger d-flex d-xl-none"
        aria-label="Mega navigation burger-button"
      >
        <i className="bi bi-list fs-3" aria-hidden={true} />
      </button>
      <ul className="d-none d-xl-flex meganav__list">
        {categories().map((category, index) => (
          <MegaNavigationMenuItem
            key={index}
            active={category === activeCategory}
            category={category}
            onSetActiveCategory={setActiveCategory}
          />
        ))}
      </ul>
      <MegaNavigationBodyMobile
        categories={categories()}
        onCloseMobileMenu={() => toggleMobileMenu(false)}
        className={`${isMobileMenuOpen ? 'active' : ''} d-block d-xl-none`}
      />
    </nav>
  );
};

export default withDatasourceCheck()<MegaNavigationProps>(MegaNavigation);
